<template>
    <div class="user-menu flexbox flex-justify-content-end">
        <div>
            <v-menu
                v-model="showMenu"
                v-if="token && profile"
                :close-on-content-click="false"
                :nudge-top="-8"
                offset-y
            >
                <template v-slot:activator="{ on }">
                    <div v-if="token" class="user-box" >
                        <v-btn
                            flat
                            :color="$vuetify.theme.white"
                            v-on="on"
                            class="btn-remove-hover"
                            :ripple="false"
                        >
                            <div class="centerY">
                                <div class="mr-1">
                                    <div class="username">
                                        <template v-if="profile">
                                            {{
                                                !profile.name || profile.name === ""
                                                    ? emailName(profile.email)
                                                    : profile.name
                                            }}
                                        </template>
                                        <template v-else>
                                            Unknown
                                        </template>
                                    </div>
                                    <div class="user-email" v-if="profile">{{ profile.email }}</div>
                                </div>
                                <img src="/img/dropdown.svg" alt="icon-dropdown">
                            </div>
                        </v-btn>
                    </div>
                </template>
                <v-card>
                    <template v-if="platformVersion">
                        <table>
                            <tr>
                                <td>Platform Version</td>
                                <td>{{ platformVersion }}</td>
                            </tr>
                        </table>
                        <v-divider></v-divider>
                    </template>
                    
                    <template v-if="isAdmin()">
                        <table>
                            <tr>
                                <td>UI Version</td>
                                <td>v{{ versionUI }}</td>
                            </tr>
                            <tr v-if="isDevOrStaging()">
                                <td>Token</td>
                                <td>
                                    <div class="token-val">
                                        <img
                                            src="/img/copy-1_grey.svg"
                                            alt="icon-copy-token"
                                            class="icon-copy"
                                            @click="$utils.copyToClipboard(token, $f.tc('copyTokenSuccess')); showMenu=false"
                                        >
                                        {{ $utils.limitStringLength(token, 20) }}
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="isDevOrStaging()">
                                <td>Token Expire</td>
                                <td>{{ tokenExpire }}</td>
                            </tr>
                            <tr v-if="isDevOrStaging()">
                                <td>Refresh Token</td>
                                <td>
                                    <div class="token-val">
                                        <img
                                            src="/img/copy-1_grey.svg"
                                            alt="icon-copy-token"
                                            class="icon-copy"
                                            @click="$utils.copyToClipboard(refreshToken, $f.tc('copyRefreshTokenSuccess')); showMenu=false"
                                        >
                                        {{ $utils.limitStringLength(refreshToken, 20) }}
                                    </div>
                                </td>
                            </tr>
                        </table>
                        <v-divider></v-divider>
                    </template>
                    
                    <template v-if="notProduction">
                        <table>
                            <tr>
                                <td>Env</td>
                                <td>{{ appEnv }}</td>
                            </tr>
                            <tr>
                                <td>Build</td>
                                <td>{{ buildTime }}</td>
                            </tr>
                            <tr>
                                <td>Roles</td>
                                <td>{{ profile.roles }}</td>
                            </tr>
                        </table>
                        <v-divider></v-divider>
                    </template>
                    
                    <v-card-actions>
                        <v-spacer />
                        <div class="btn-sign-out" @click="signOut">
                            <img src="/img/logout.svg" alt="icon-logout">
                            {{ $f.tc("signOut") }}
                        </div>
                    </v-card-actions>
                </v-card>
            </v-menu>
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex'
import AuthService from "@/services/auth.service"
import moment from 'moment'
import {version} from '../../../../package.json'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin.vue'

export default {
    name: 'UserMenu',
    mixins: [RoleMixin],
    data() {
        return {
            versionUI: version,
            showMenu: false,
            appEnv: process.env.NODE_ENV,
            userProfileUrl:
                process.env.VUE_APP_AUTHENTICATION_SERVICE === this.$const.authenticationService.SELF
                    ? ''
                    : process.env.VUE_APP_PROFILE_END_POINT,
            buildTime: moment(Number(process.env.VUE_APP_BUILD_TIME)).format('HH:mm:ss DD-MM-YYYY'),
            notProduction: process.env.NODE_ENV !== this.$const.env.PRO,
        }
    },
    computed: {
        ...mapState({
            profile: state => state.user.profile,
            platformVersion: state => state.version,
            token: state => state.user.token,
            refreshToken: state => state.user.refreshToken,
            tokenExpire: state => {
                if (state.user.token) {
                    return moment(AuthService.decodeJWT(state.user.token).exp * 1000).format('HH:mm:ss')
                }
                return 0
            }
        }),
    },
    methods: {
        signOut() {
            this.$store.dispatch(this.$actionTypes.user.SIGN_OUT)
        },
        emailName(email) {
            if (email) {
                email = email.substring(0, email.lastIndexOf('@'))
            }
            return email
        },
        show() {
            this.showMenu = true
        },
        isDevOrStaging() {
            const envs = ['dev', 'staging']
            return envs.includes(process.env.VUE_APP_SENTRY_ENVIRONMENT)
        },
    }
}
</script>
<style scoped lang="scss">
.username {
    font-weight: bold;
}

.token-val {
    display: flex;
    align-items: center;
    
    .icon-copy {
        margin-right: 4px;
        cursor: pointer;
        width: 15px;
    }
}

.to-view {
    cursor: pointer;

    &:hover {
        background: #f0f0f0;
    }
}

.btn-sign-out {
    width: 100%;
    height: 32px;
    border-radius: 5px;
    font-weight: bold;
    font-size: 14px;
    text-transform: uppercase;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0052CC;
    
    &:hover {
        background: #e4edfa;
    }
    
    img {
        width: 18px;
        margin-right: 6px;
    }
}

table {
    width: 100%;
    font-size: 14px;
    padding: 5px 0;
    
    tr td {
        padding: 2px 10px;
        &:first-child {
            font-weight: bold;
            padding-right: 10px;
            width: 128px;
        }
        
        &:not(:first-child) {
            text-align: right;
        }
    }
}

::v-deep {
    .v-btn {
        padding: 0 12px !important;
    }
    
    .v-menu__content {
        min-width: 200px !important;
    }
}
</style>